import { getMaxWidthMediaQuery } from "@acin.reactjs/acin-ui/theme";
import { DefaultTheme } from "styled-components";
import merge from "lodash/merge";

const GridTheme = (theme: DefaultTheme) =>
  merge(
    {},
    {
      variants: {
        buttonsEndContainer: {
          container: {
            marginTop: "40px",
            justifyItems: "end",
            width: "100%",
          },
        },
        buttonsEndContainerWithScroll: {
          container: {
            marginTop: "10px",
            justifyItems: "end",
            width: "100%",
          },
        },
        buttonsEndContainerSubscription: {
          container: {
            marginTop: "10px",
            justifyItems: "end",
            width: "100%",
            paddingBottom: "20px",

            [getMaxWidthMediaQuery(theme.breakpoints.sm)]: {
              paddingBottom: "0px",
            },
          },
        },
        allWidthItem: {
          item: {
            [getMaxWidthMediaQuery(theme.breakpoints.sm)]: {
              width: "100%",
              "& button": {
                width: "100%",
              },
            },
          },
        },
        halfButtonWidthItem: {
          item: {
            [getMaxWidthMediaQuery(theme.breakpoints.sm)]: {
              width: "100%",
              "& button": {
                width: "48%",
              },
            },
          },
        },
        viewAdsButtons: {
          container: {
            marginTop: "32px",

            [getMaxWidthMediaQuery(theme.breakpoints.sm)]: {
              marginTop: "0px",
            },
          },
        },
      },
    },
    theme.components?.grid || {},
  );

export default GridTheme;
